import { fillNum } from '@/utils';
import { Countdown } from '@tencent/wphk-components-common/utils/countdown';
import { computed, reactive, onMounted, onUnmounted } from '@vue/composition-api';

/**
 * 倒计时hooks
 * @param startDate 开始日期
 * @param endDate 结束日期
 */
export function useCountdown(startDate: Date, endDate: Date) {
  let countdown: Countdown | undefined;
  const countdownData = reactive({
    day: Infinity,
    hours: Infinity,
    minutes: Infinity,
    seconds: Infinity,
  });
  onMounted(() => {
    countdown = new Countdown(startDate, endDate, 1000, (dateInfo) => {
      const { day, hours, minutes, seconds } = dateInfo;
      Object.assign(countdownData, { day, hours, minutes, seconds });
    });
  });
  onUnmounted(() => {
    if (countdown) countdown.delete();
  });
  const countdownText = computed(() => {
    const { day, hours, minutes, seconds } = countdownData;
    return {
      minutes: [day, hours, minutes].map((item) => fillNum(item, 2)).join(':'),
      seconds: [day, hours, minutes, seconds].map((item) => fillNum(item, 2)).join(':'),
    };
  });
  const isCountdownEnd = computed(() => countdownText.value.seconds === '00:00:00:00');
  return {
    /** 原始countdown实例 */
    countdown,
    /** 倒计时数据 */
    countdownData,
    /** 倒计时字符串：seconds: 01:12:30:59, minutes: 01:12:30*/
    countdownText,
    /** 倒计时是否结束 */
    isCountdownEnd,
  };
}
